import sdl from '@jds/react-generated-sdl/JDSTabItem';
import type { JDSTabItemProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, TabItemProps } from '../logic';

const Component = (props: TabItemProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    state = 'inactive',
    kind = 'label_icon',
    appearance = 'normal',
    disabled = false,
    ariaLabel = props.label?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { state, kind, appearance, disabled, ariaLabel, ...rest },
    'JDSTabItem',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const TabItem = withLogic(Component) as React.FC<TabItemProps> & {
  slotName?: string;
};

TabItem.displayName = 'TabItem';
TabItem.slotName = 'jds_tab_item';

export { TabItem, type JDSTabItemProps };
